
import { authExternal } from '@/helpers/AuthExternal'
import { openLoginModal } from '@/modals/loginModal'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'LoginLink',
})
export default class extends Vue {
  onClick() {
    const { login, isExternalAuth } = authExternal

    if (isExternalAuth()) {
      login(this.$route.fullPath)
    } else {
      openLoginModal()
        .then(() => this.$emit('success'))
        // TODO Reject the promise from openLoginModal() when the modal is dismissed.
        .catch(() => this.$emit('dismissed'))
    }
  }
}
